import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="notfound-container">
      <h1 className="notfound-404">404</h1>
      <p className="notfound-text">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="notfound-button">Go Home</Link>
    </div>
  );
};

export default NotFound;
